import React, { useState, useEffect } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import DragIndicatorIcon from '../../../Assets/Icons/DragIndicatorIcon';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { notification, Modal, Input, Button, Switch, Select, Form, Checkbox, Row, Col, Tooltip, Divider, message, Dropdown, Menu, Tag } from 'antd';
import { createGlobalStyle } from 'styled-components';
import { PlusOutlined, SearchOutlined, DownOutlined, ArrowLeftOutlined, ArrowDownOutlined, DownloadOutlined, ExclamationCircleOutlined, SwapOutlined, DeleteOutlined } from '@ant-design/icons';
import PageTitle from '../../../Utils/PageTitle';
import Spinner from '../../CustomComponents/Spinner';
import CustomTypography from '../../CustomComponents/CustomTypography';
import { ContainerRow, TitleRow } from '../styledComponents';
import {
  listDictationTemplate,
  saveDictationTemplate,
  editDictationTemplate,
  removeDictationTemplate,
  getAllCannedText,
  getSupportedSections,
  editCannedText,
  saveCannedText,
  targetEndPoints,
  removeCannedTexts,
  authorsCollectionToMyCollectionDict,
  templateMappingStatus,
} from '../../../Apis/Author';
import {
  CustomModalforAddk2p,
  CustomModal,
  K2pButtonsecnd,
  SearchInputStylee,
  SearchDivider,
  Keytophraseduplication,
  KpCol,
} from '../KeyToPhrase/styledComponents';
import AddKeyToPhraseForm from '../KeyToPhrase/AddKeyToPhraseForm';
import AIGenerateModal from './AIGenerateModal';
import BreadCrumbComponent from '../../CustomComponents/BreadCrumbComponent';
import { MappedValues, MappedValuesContainer, DeleteConfirmationMessage } from '../Dictation/styledComponents';
import ConfirmationModal from '../../CustomComponents/ConfirmationModal';
import { AddButton } from '../styledComponents';
import {
  NavTabs,
  NavTab,
  PageWrapper,
  Sidebar,
  SidebarHeader,
  SidebarSearch,
  TemplateListScroll,
  TemplateItem,
  TemplateName,
  TemplateMeta,
  NewTemplateBtn,
  MainPanel,
  EmptyState,
  EmptyStateIcon,
  EmptyStateText,
  EmptyStateSubtext,
  EditorContainer,
  EditorBreadcrumb,
  BreadcrumbLink,
  EditorActions,
  EditorLayout,
  EditorMain,
  EditorRight,
  EditorBody,
  FieldGroup,
  FieldLabel,
  ConfigBar,
  ConfigItem,
  SectionDivider,
  HeadingCard,
  HeadingGrip,
  HeadingHeader,
  HeadingTitle,
  HeadingSystemTag,
  HeadingChevron,
  HeadingBody,
  ToggleGrid,
  ToggleRow,
  SubLabel,
  HeadingTextArea,
  AiPromptWrap,
  AiPromptHead,
  AiPromptField,
  K2pPanelHeader,
  K2pPanelSearch,
  K2pPanelScroll,
  K2pSectionLabel,
  K2pItem,
  K2pItemTop,
  K2pItemKey,
  K2pBadge,
  K2pItemPhrase,
  AddHeadingBtn,
  SectionGroupCard,
  SectionGroupHeader,
  SectionGroupTitle,
  SectionGroupBadge,
  SectionGroupBody,
  AddGroupHeadingBtn,
  SectionTypeBar,
  SectionTypeBtn,
  OptionListWrap,
  OptionRow,
  AddOptionBtn,
} from './styledComponents';

const ModalStyles = createGlobalStyle`
  .template-new-modal .ant-modal-content {
    border-radius: 10px;
    overflow: hidden;
  }
  .heading-default-editor {
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    padding: 8px 11px;
    font-size: 13px;
    min-height: 62px;
    line-height: 1.9;
    outline: none;
    color: #262626;
    font-family: inherit;
    margin-bottom: 12px;
    transition: border-color 0.3s;
    word-break: break-word;
  }
  .heading-default-editor:focus {
    border-color: #47A4EA;
    box-shadow: 0 0 0 2px rgba(71, 164, 234, 0.2);
  }
  .heading-default-editor.drag-over {
    border: 1px dashed #47A4EA;
    background: #e6f7ff;
  }
  .heading-default-editor:empty::before {
    content: attr(data-placeholder);
    color: #bfbfbf;
    font-style: italic;
    pointer-events: none;
  }
  .k2p-token {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    padding: 1px 8px 1px 10px;
    background: #e6f7ff;
    color: #1d7ec2;
    border: 1px solid #91d5ff;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 500;
    cursor: default;
    user-select: none;
    margin: 0 2px;
    vertical-align: middle;
    line-height: 1.6;
  }
  .k2p-token-remove {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    cursor: pointer;
    color: #1d7ec2;
    font-size: 13px;
    line-height: 1;
    opacity: 0.6;
    flex-shrink: 0;
  }
  .k2p-token-remove:hover {
    opacity: 1;
    background: #91d5ff;
  }
  .heading-system-select .ant-select-selector {
    border-radius: 6px !important;
  }
`;

function stripHtml(html) {
  if (!html) return '';
  return html.replace(/<[^>]*>/g, '').trim();
}

function stripPillsToPlainText(html) {
  if (!html) return '';
  const tmp = document.createElement('div');
  tmp.innerHTML = html;
  tmp.querySelectorAll('[data-action="k2p-remove"]').forEach(el => el.remove());
  tmp.querySelectorAll('[data-k2p-id]').forEach(el => {
    el.parentNode.replaceChild(document.createTextNode(el.textContent.trim() + ' '), el);
  });
  tmp.querySelectorAll('br').forEach(el => el.replaceWith('\n'));
  tmp.querySelectorAll('p, div').forEach(el => {
    el.prepend('\n');
  });
  const text = tmp.textContent.replace(/ /g, ' ').replace(/[ \t]+/g, ' ').replace(/\n[ \t]*/g, '\n').trim();
  return text ? `<p>${text}</p>` : '';
}

function buildCannedTextsWithHeadings(sectionHeadings) {
  const map = new Map();
  sectionHeadings.forEach(h => {
    if (!h.defaultValue) return;
    const seen = new Set();
    for (const m of h.defaultValue.matchAll(/data-k2p-id="([^"]+)"/g)) {
      if (seen.has(m[1])) continue;
      seen.add(m[1]);
      if (!map.has(m[1])) map.set(m[1], []);
      map.get(m[1]).push(h.customUIHeading);
    }
  });
  return Array.from(map.entries()).map(([cannedTextId, headings]) => ({ cannedTextId, headings }));
}

function eligibleK2psForTemplate(k2pList, templateId) {
  return (k2pList || []).filter(k => {
    if (!k.restrictedToTemplates) return true;
    if (!templateId || !k.templateMapping?.length) return false;
    return k.templateMapping.some(m => m.templateId === templateId);
  });
}

function applyPillsFromText(html, k2pList) {
  if (!html) return html;
  const normalized = html.replace(/ /g, ' ').replace(/\n/g, '<br>');
  if (!k2pList?.length) return normalized;
  const tmp = document.createElement('div');
  tmp.innerHTML = normalized;
  if (tmp.querySelector('[data-k2p-id]')) return normalized;

  const sorted = [...k2pList].sort((a, b) => b.key.length - a.key.length);
  const escapedKeys = sorted.map(k => k.key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
  const dollarForm = `\\$\\{\\s*(${escapedKeys.join('|')})\\s*\\}`;
  const bareForm = `(?<!\\w)(${escapedKeys.join('|')})(?!\\w)`;
  const regex = new RegExp(`${dollarForm}|${bareForm}`, 'gi');
  const keyMap = new Map(sorted.map(k => [k.key.toLowerCase(), k]));

  const walker = document.createTreeWalker(tmp, NodeFilter.SHOW_TEXT);
  const textNodes = [];
  let node;
  while ((node = walker.nextNode())) textNodes.push(node);

  textNodes.forEach(textNode => {
    const text = textNode.textContent;
    if (!text.trim()) return;

    const fragment = document.createDocumentFragment();
    let lastIndex = 0;
    regex.lastIndex = 0;
    let match;
    while ((match = regex.exec(text)) !== null) {
      const matchedKey = (match[1] ?? match[2])?.toLowerCase().trim();
      const k2p = matchedKey ? keyMap.get(matchedKey) : null;
      if (!k2p) continue;
      if (match.index > lastIndex) {
        fragment.appendChild(document.createTextNode(text.slice(lastIndex, match.index)));
      }
      const pill = document.createElement('span');
      pill.setAttribute('data-k2p-id', k2p.id);
      pill.setAttribute('contenteditable', 'false');
      pill.className = 'k2p-token';
      const removeBtn = document.createElement('span');
      removeBtn.setAttribute('data-action', 'k2p-remove');
      removeBtn.setAttribute('data-k2p-id', k2p.id);
      removeBtn.className = 'k2p-token-remove';
      removeBtn.textContent = '×';
      pill.appendChild(document.createTextNode(k2p.key));
      pill.appendChild(removeBtn);
      fragment.appendChild(pill);
      lastIndex = match.index + match[0].length;
    }
    if (lastIndex === 0) return;
    if (lastIndex < text.length) {
      fragment.appendChild(document.createTextNode(text.slice(lastIndex)));
    }
    textNode.parentNode.replaceChild(fragment, textNode);
  });

  return tmp.innerHTML;
}

const EditK2pModal = ({ item, onClose, dynamicEndPoints, onSaveSuccess, onDeleteSuccess }) => {
  const [form] = Form.useForm();
  const [submitLoading, setSubmitLoading] = useState(false);
  const [activeEnable, setActiveEnable] = useState(item.active || false);
  const [submitDisabled, setSubmitDisabled] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [toActive, setToActive] = useState(false);
  const [treeVisible, setTreeVisible] = useState(item.restrictedToTemplates || false);
  const [k2pMapping, setK2pMapping] = useState([]);
  const [loadingTree, setLoadingTree] = useState(false);
  const [selectedFields, setSelectedFields] = useState([]);
  let updatedK2pMappingkeys = [];

  useEffect(() => {
    const newSelectedFields = [];
    // Fully-selected templates: push the template item (parent node key = template id)
    k2pMapping.filter(t => t.selected).forEach(t => newSelectedFields.push(t));
    // Partially-selected templates: push only the selected section heading items
    k2pMapping
      .filter(t => t.selected === false && t.sectionHeadings.some(h => h.selected))
      .forEach(t => {
        t.sectionHeadings.filter(h => h.selected).forEach(h => newSelectedFields.push(h));
      });
    setSelectedFields(newSelectedFields);
  }, [k2pMapping]);

  const toggleTreeVisibility = (newValue, templateMapping) => {
    setLoadingTree(true);
    if (newValue === true) {
      templateMappingStatus()
        .then(response => {
          if (response.data.success) {
            if (templateMapping) {
              templateMapping.forEach(templateItem => {
                const idx = response.data.result.findIndex(t => t.id === templateItem.templateId);
                if (idx !== -1) {
                  response.data.result[idx].selected = templateItem.allHeadings;
                  if (templateItem.allHeadings !== true) {
                    response.data.result[idx].sectionHeadings.forEach(sh => {
                      if (templateItem.templateHeadings && templateItem.templateHeadings.includes(sh.customUIHeading)) {
                        sh.selected = true;
                      }
                    });
                  } else {
                    response.data.result[idx].sectionHeadings.forEach(sh => { sh.selected = true; });
                  }
                }
              });
            }
            const updatedMapping = response.data.result.map((template, ti) => {
              template.sectionHeadings = template.sectionHeadings.map((heading, hi) => {
                const id = `0-${ti}-${hi}`;
                if (heading.selected) updatedK2pMappingkeys.push(id);
                return { ...heading, id };
              });
              return template;
            });
            setK2pMapping(updatedMapping);
          } else {
            notification.error({ message: 'Failed', description: response.data.message });
          }
        })
        .catch(() => {})
        .finally(() => setLoadingTree(false));
      setTreeVisible(true);
    } else {
      setLoadingTree(false);
      setTreeVisible(false);
    }
  };

  const handleCheck = (checkedKeys, { node }) => {
    setSubmitDisabled(true);
    setK2pMapping(prev =>
      prev.map(t => {
        if (t.id === node.key) {
          t.sectionHeadings = t.sectionHeadings.map(sh => ({ ...sh, selected: !sh.selected }));
          t.selected = !t.selected;
        } else {
          t.sectionHeadings = t.sectionHeadings.map(sh =>
            sh.id === node.key ? { ...sh, selected: !sh.selected } : sh
          );
          t.selected = t.sectionHeadings.every(sh => sh.selected);
        }
        return t;
      })
    );
  };

  useEffect(() => {
    if (item.restrictedToTemplates) {
      toggleTreeVisibility(true, item.templateMapping);
    }
  }, []);

  const handleSubmit = values => {
    values.phrase = values.phrase
      .replace(/<\/p>/g, '</p><br>')
      .replace(/<p><br><\/p><br>/g, '<br>')
      .replace(/<br>$/g, '');
    values.targetEndPoint =
      values.targetEndPoint === '' || values.dynamic == false ? null : values.targetEndPoint;
    values.templateMapping = k2pMapping
      .map(t => ({
        allHeadings: t.selected,
        templateHeadings: t.sectionHeadings.filter(h => h.selected).map(h => h.customUIHeading),
        templateId: t.id,
      }))
      .filter(t => t.templateHeadings.length > 0);
    const payload = { ...values, id: item.id };
    payload.defaultValue = values.dynamic && values.defaultValue ? String(values.defaultValue) : '';
    setSubmitLoading(true);
    editCannedText(payload)
      .then(res => {
        if (res?.data?.success) {
          notification.success({ message: 'Success', description: res.data.message });
          onSaveSuccess({ ...item, key: payload.key || item.key, phrase: payload.phrase || item.phrase });
          onClose();
        } else {
          notification.error({ message: 'Failed', description: res.data.message });
        }
      })
      .catch(() => {})
      .finally(() => setSubmitLoading(false));
  };

  const handleDeleteClick = () => {
    setSubmitLoading(true);
    removeCannedTexts(item.id)
      .then(res => {
        if (res?.data?.success) {
          notification.success({ message: 'Success', description: res.data.message });
          setDeleteModal(false);
          onDeleteSuccess(item.id);
          onClose();
        } else {
          notification.error({ message: 'Failed', description: res.data.message });
          setDeleteModal(false);
        }
      })
      .catch(() => {})
      .finally(() => setSubmitLoading(false));
  };

  return (
    <CustomModalforAddk2p
      title='Edit Key'
      visible
      onCancel={onClose}
      footer={[
        <Button key='delete' shape='round' danger onClick={() => setDeleteModal(true)}>
          Delete
        </Button>,
        <Button
          key='save'
          type='primary'
          shape='round'
          disabled={!submitDisabled}
          loading={submitLoading}
          onClick={() => form.submit()}
        >
          Save
        </Button>,
        <Button key='close' shape='round' onClick={onClose}>
          Close
        </Button>,
      ]}
      destroyOnClose
    >
      <AddKeyToPhraseForm
        form={form}
        activeEnable={activeEnable}
        setActiveEnable={setActiveEnable}
        selectedItem={item}
        selectedItemColumn='Mine'
        submitHandler={handleSubmit}
        setSubmitDisabled={setSubmitDisabled}
        submitDisabled={submitDisabled}
        submitLoading={submitLoading}
        handleDeleteClick={handleDeleteClick}
        handleMineDelete={() => setDeleteModal(true)}
        deleteModal={deleteModal}
        dynamicEndPoints={dynamicEndPoints}
        k2pMapping={k2pMapping}
        treeVisible={treeVisible}
        toggleTreeVisibility={toggleTreeVisibility}
        handleCheck={handleCheck}
        loadingTree={loadingTree}
        handleActiveClickChange={() => {}}
        handleFormValuesChange={() => setSubmitDisabled(true)}
        handleActivateToggleSave={() => {}}
        selectedPhrase={item.phrase}
        selectedFields={selectedFields}
        updatedK2pMappingkeys={updatedK2pMappingkeys}
        showTable={() => {}}
        toggleActive={() => setToActive(v => !v)}
        toActive={toActive}
        templateMappingModified={false}
      />
    </CustomModalforAddk2p>
  );
};

const CreateK2pModal = ({ onClose, dynamicEndPoints, onCreateSuccess }) => {
  const [form] = Form.useForm();
  const [submitLoading, setSubmitLoading] = useState(false);
  const [activeEnable, setActiveEnable] = useState(true);
  const [submitDisabled, setSubmitDisabled] = useState(false);
  const [toActive, setToActive] = useState(false);
  const [treeVisible, setTreeVisible] = useState(false);
  const [k2pMapping, setK2pMapping] = useState([]);
  const [loadingTree, setLoadingTree] = useState(false);
  const [selectedFields, setSelectedFields] = useState([]);
  let updatedK2pMappingkeys = [];

  useEffect(() => {
    const newSelectedFields = [];
    k2pMapping.filter(t => t.selected).forEach(t => newSelectedFields.push(t));
    k2pMapping
      .filter(t => t.selected === false && t.sectionHeadings.some(h => h.selected))
      .forEach(t => {
        t.sectionHeadings.filter(h => h.selected).forEach(h => newSelectedFields.push(h));
      });
    setSelectedFields(newSelectedFields);
  }, [k2pMapping]);

  const toggleTreeVisibility = newValue => {
    setLoadingTree(true);
    if (newValue === true) {
      templateMappingStatus()
        .then(response => {
          if (response.data.success) {
            const updatedMapping = response.data.result.map((template, ti) => {
              template.sectionHeadings = template.sectionHeadings.map((heading, hi) => ({
                ...heading,
                id: `0-${ti}-${hi}`,
              }));
              return template;
            });
            setK2pMapping(updatedMapping);
          } else {
            notification.error({ message: 'Failed', description: response.data.message });
          }
        })
        .catch(() => {})
        .finally(() => setLoadingTree(false));
      setTreeVisible(true);
    } else {
      setLoadingTree(false);
      setTreeVisible(false);
    }
  };

  const handleCheck = (checkedKeys, { node }) => {
    setSubmitDisabled(true);
    setK2pMapping(prev =>
      prev.map(t => {
        if (t.id === node.key) {
          t.sectionHeadings = t.sectionHeadings.map(sh => ({ ...sh, selected: !sh.selected }));
          t.selected = !t.selected;
        } else {
          t.sectionHeadings = t.sectionHeadings.map(sh =>
            sh.id === node.key ? { ...sh, selected: !sh.selected } : sh
          );
          t.selected = t.sectionHeadings.every(sh => sh.selected);
        }
        return t;
      })
    );
  };

  const handleSubmit = values => {
    values.phrase = values.phrase
      .replace(/<\/p>/g, '</p><br>')
      .replace(/<p><br><\/p><br>/g, '<br>')
      .replace(/<br>$/g, '');
    values.targetEndPoint = values.targetEndPoint === '' || values.dynamic == false ? null : values.targetEndPoint;
    values.templateMapping = k2pMapping
      .map(t => ({
        allHeadings: t.selected,
        templateHeadings: t.sectionHeadings.filter(h => h.selected).map(h => h.customUIHeading),
        templateId: t.id,
      }))
      .filter(t => t.templateHeadings.length > 0);
    const payload = { ...values };
    payload.defaultValue = values.dynamic && values.defaultValue ? String(values.defaultValue) : '';
    setSubmitLoading(true);
    saveCannedText(payload)
      .then(res => {
        if (res?.data?.success) {
          notification.success({ message: 'Success', description: res.data.message });
          onCreateSuccess();
          onClose();
        } else {
          notification.error({ message: 'Failed', description: res.data.message });
        }
      })
      .catch(() => {})
      .finally(() => setSubmitLoading(false));
  };

  return (
    <CustomModalforAddk2p
      title='Add Key'
      visible
      onCancel={onClose}
      footer={[
        <Button key='save' type='primary' shape='round' disabled={!submitDisabled} loading={submitLoading} onClick={() => form.submit()}>Submit</Button>,
        <Button key='close' shape='round' onClick={onClose}>Close</Button>,
      ]}
      destroyOnClose
    >
      <AddKeyToPhraseForm
        form={form}
        activeEnable={activeEnable}
        setActiveEnable={setActiveEnable}
        selectedItem={null}
        selectedItemColumn='Mine'
        submitHandler={handleSubmit}
        setSubmitDisabled={setSubmitDisabled}
        submitDisabled={submitDisabled}
        submitLoading={submitLoading}
        handleDeleteClick={() => {}}
        handleMineDelete={() => {}}
        deleteModal={false}
        dynamicEndPoints={dynamicEndPoints}
        k2pMapping={k2pMapping}
        treeVisible={treeVisible}
        toggleTreeVisibility={toggleTreeVisibility}
        handleCheck={handleCheck}
        loadingTree={loadingTree}
        handleActiveClickChange={() => {}}
        handleFormValuesChange={() => setSubmitDisabled(true)}
        handleActivateToggleSave={() => {}}
        selectedPhrase={null}
        selectedFields={selectedFields}
        updatedK2pMappingkeys={updatedK2pMappingkeys}
        showTable={() => {}}
        toggleActive={() => setToActive(v => !v)}
        toActive={toActive}
        templateMappingModified={false}
      />
    </CustomModalforAddk2p>
  );
};

const TemplateList = () => {
  const theme = useSelector(state => state.themeReducer);
  const user = useSelector(state => state.userReducer);
  const history = useHistory();
  const location = useLocation();
  const [templates, setTemplates] = useState([]);
  const [filteredTemplates, setFilteredTemplates] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [loading, setLoading] = useState(false);
  const [fetchFlag, setFetchFlag] = useState(true);

  // New template modal
  const [modalOpen, setModalOpen] = useState(false);

  // AI generate modal
  const [aiGenerateModalOpen, setAiGenerateModalOpen] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [newName, setNewName] = useState('');
  const [newDesc, setNewDesc] = useState('');

  // Editor state
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [draft, setDraft] = useState(null);
  const [saveLoading, setSaveLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [deleteForAllUsers, setDeleteForAllUsers] = useState(false);
  const [isNewTemplate, setIsNewTemplate] = useState(false);

  // Collapse state for top-level items, keyed by item ID
  const [collapsedItems, setCollapsedItems] = useState(new Set());

  // Add heading modal
  const [addHeadingModalOpen, setAddHeadingModalOpen] = useState(false);
  const [newHeadingName, setNewHeadingName] = useState('');

  // Section group state
  const [addSectionGroupModalOpen, setAddSectionGroupModalOpen] = useState(false);
  const [newSectionGroupName, setNewSectionGroupName] = useState('');
  const [newSectionGroupPushTitle, setNewSectionGroupPushTitle] = useState(false);
  const [addGroupHeadingModal, setAddGroupHeadingModal] = useState({ open: false, groupId: null });
  const [newGroupHeadingName, setNewGroupHeadingName] = useState('');
  const [collapsedGroupHeadings, setCollapsedGroupHeadings] = useState(new Set());

  // System sections (for systemHeading dropdown)
  const [systemSections, setSystemSections] = useState([]);

  // K2P sidebar state
  const [k2ps, setK2ps] = useState([]);
  const [k2pFilter, setK2pFilter] = useState('');
  const [k2pLoading, setK2pLoading] = useState(false);
  const [usedK2pIds, setUsedK2pIds] = useState(new Set());
  const headingContentRefs = React.useRef({});

  // Edit / Create K2P modal state
  const [editK2pItem, setEditK2pItem] = useState(null);
  const [editK2pDynamicEndPoints, setEditK2pDynamicEndPoints] = useState([]);
  const [createK2pModalVisible, setCreateK2pModalVisible] = useState(false);

  // Import from global list state
  const [importModalVisible, setImportModalVisible] = useState(false);
  const [cannedTextAuthor, setCannedTextsAuthor] = useState([]);
  const [cannedTextAuthorSize, setCannedTextAuthorSize] = useState(0);
  const [loadingAuthor, setLoadingAuthor] = useState(false);
  const [checkedCards, setCheckedCards] = useState([]);
  const [checkedCardIds, setCheckedCardIds] = useState([]);
  const [authPage, setAuthPage] = useState(0);
  const [searchQueryAuthor, setSearchQueryAuthor] = useState('');
  const [selectedCard, setSelectedCard] = useState(null);
  const [importActive, setImportActive] = useState(false);
  const [importExportToOtherAuthors, setImportExportToOtherAuthors] = useState(false);
  const [importErrorModalVisible, setImportErrorModalVisible] = useState(false);
  const importSearchTimerRef = React.useRef(null);
  const draftSnapshotRef = React.useRef(null);
  const pendingNavAction = React.useRef(null);
  const isSaveUpdateRef = React.useRef(false);
  const [unsavedModalVisible, setUnsavedModalVisible] = useState(false);

  useEffect(() => {
    if (!fetchFlag) return;
    setFetchFlag(false);
    setLoading(true);
    let loadedTemplates = [];
    listDictationTemplate('allMine')
      .then(res => {
        if (res?.data?.success) {
          loadedTemplates = res.data.result || [];
          setTemplates(loadedTemplates);
          setFilteredTemplates(
            loadedTemplates.filter(t =>
              (t.templateName || '').toLowerCase().includes(searchValue.toLowerCase())
            )
          );
        }
        return getAllCannedText('allMine');
      })
      .then(k2pRes => {
        if (!k2pRes) return;
        if (k2pRes?.data?.success || k2pRes?.data?.result) {
          const result = k2pRes?.data?.result || [];
          setK2ps(result);

          // Edge case: user selected a template before k2ps finished loading
          let transformedHeadings = null;
          setDraft(d => {
            if (!d?.items?.length) return d;
            const items = d.items.map(item => {
              if (item.type === 'heading') {
                return { ...item, defaultValue: applyPillsFromText(item.defaultValue, eligibleK2psForTemplate(result, d.id)) };
              }
              if (item.type === 'sectionGroup') {
                return {
                  ...item,
                  headings: item.headings.map(h => ({ ...h, defaultValue: applyPillsFromText(h.defaultValue, eligibleK2psForTemplate(result, d.id)) })),
                };
              }
              return item;
            });
            transformedHeadings = items.filter(i => i.type === 'heading');
            return { ...d, items };
          });
          if (transformedHeadings) {
            const newIds = new Set();
            transformedHeadings.forEach(h => {
              if (!h.defaultValue) return;
              for (const m of h.defaultValue.matchAll(/data-k2p-id="([^"]+)"/g)) newIds.add(m[1]);
            });
            setUsedK2pIds(newIds);
            if (newIds.size > 0) {
              setDraft(d => d ? { ...d, keytophraseEnabled: true } : d);
            }
          }

          // Auto-select template after k2ps are loaded so useEffect([selectedTemplate])
          // fires with a populated k2ps list and applyPillsFromText works correctly.
          const openId = location.state?.openTemplateId;
          if (openId) {
            const target = loadedTemplates.find(t => t.id === openId);
            if (target) setSelectedTemplate(target);
            history.replace(location.pathname, {});
          }
        }
      })
      .catch(() => {
        notification.error({ message: 'Failed to load templates' });
      })
      .finally(() => setLoading(false));
  }, [fetchFlag]);

  // Initialise draft whenever a template is opened
  useEffect(() => {
    if (selectedTemplate) {
      if (isSaveUpdateRef.current) {
        isSaveUpdateRef.current = false;
        return;
      }
      const FIELD_TYPE_TO_SECTION_TYPE = { CHECKBOX: 'checkbox', DROPDOWN: 'droplist' };

      const mapHeading = (h, fallbackId) => ({
        ...h,
        type: 'heading',
        id: h.id || fallbackId,
        sectionType: FIELD_TYPE_TO_SECTION_TYPE[h.fieldType] || 'dictate',
        options: (h.options || []).map(v => ({ value: v })),
        defaultValue: applyPillsFromText(h.defaultValue, eligibleK2psForTemplate(k2ps, selectedTemplate?.id)),
      });

      const items = (selectedTemplate.sectionHeadings || []).map((item, i) => {
        if (item.type === 'SECTION_GROUP') {
          return {
            ...item,
            type: 'sectionGroup',
            id: item.id || `group-${i}`,
            title: item.customUIHeading,
            headings: (item.children || []).filter(Boolean).map((h, j) =>
              mapHeading(h, `gh-${item.id || i}-${j}`)
            ),
          };
        }
        return mapHeading(item, `h-${i}`);
      });

      const preUsed = new Set();
      items.flatMap(item => item.type === 'sectionGroup' ? (item.headings || []) : [item])
        .forEach(h => {
          if (!h.defaultValue) return;
          for (const m of h.defaultValue.matchAll(/data-k2p-id="([^"]+)"/g)) preUsed.add(m[1]);
        });

      const initialDraft = {
        id: selectedTemplate?.id || null,
        templateName: selectedTemplate.templateName || '',
        templateDescription: selectedTemplate.templateDescription || '',
        global: selectedTemplate.global || false,
        active: selectedTemplate.active || false,
        keytophraseEnabled: true,
        exportToOtherAuthors: selectedTemplate.exportToOtherAuthors ?? false,
        items,
      };
      setDraft(initialDraft);
      setCollapsedItems(new Set());
      setCollapsedGroupHeadings(new Set());
      setK2pFilter('');
      setUsedK2pIds(preUsed);
      draftSnapshotRef.current = JSON.stringify(initialDraft);
    }
  }, [selectedTemplate]);

  // Fetch supported system headings once on mount
  useEffect(() => {
    getSupportedSections()
      .then(res => {
        if (res?.data?.success) setSystemSections(res.data.result || []);
      })
      .catch(() => {});
  }, []);

  const refetchTemplates = () => setFetchFlag(true);

  const handleSearch = e => {
    const val = e.target.value;
    setSearchValue(val);
    setFilteredTemplates(
      templates.filter(t =>
        (t.templateName || '').toLowerCase().includes(val.toLowerCase())
      )
    );
  };

  const openModal = () => {
    setNewName('');
    setNewDesc('');
    setModalOpen(true);
  };

  const handleCreate = () => {
    const name = newName.trim();
    if (!name) {
      notification.warning({ message: 'Template name is required' });
      return;
    }
    setModalOpen(false);
    setIsNewTemplate(true);
    setSelectedTemplate({
      templateName: name,
      templateDescription: newDesc.trim(),
      sectionHeadings: [],
      global: false,
      active: false,
      keytophraseEnabled: true,
      exportToOtherAuthors: false,
    });
  };

  const handleSave = (onSuccess) => {
    if (!draft.templateName.trim()) {
      notification.warning({ message: 'Template name is required' });
      return;
    }
    setSaveLoading(true);

    const buildHeadingPayload = h => {
      const fieldType = h.sectionType === 'checkbox' ? 'CHECKBOX'
        : h.sectionType === 'droplist' ? 'DROPDOWN'
        : 'TEXT';
      const result = {
        customUIHeading: h.customUIHeading,
        systemHeading: h.systemHeading,
        description: h.description,
        defaultValue: (fieldType === 'CHECKBOX' || fieldType === 'DROPDOWN') ? null : stripPillsToPlainText(h.defaultValue),
        appendToDefault: h.appendToDefault,
        submitToEmr: h.submitToEmr,
        suppressOnEmpty: h.suppressOnEmpty,
        useAI: h.useAI,
        aiPrompt: h.aiPrompt,
        required: h.required,
        type: 'HEADING',
        fieldType,
      };
      if (h.id) result.id = h.id;
      if (fieldType === 'CHECKBOX' || fieldType === 'DROPDOWN') {
        result.options = (h.options || []).map(o => o.value).filter(Boolean);
      }
      return result;
    };

    const allHeadings = (draft.items || []).flatMap(item =>
      item.type === 'sectionGroup' ? (item.headings || []) : [item]
    );
    const cannedTextsWithHeadings = buildCannedTextsWithHeadings(allHeadings);

    const sectionHeadings = (draft.items || []).map(item => {
      if (item.type === 'sectionGroup') {
        const sg = {
          customUIHeading: item.title,
          type: 'SECTION_GROUP',
          push_title_to_note: item.push_title_to_note || false,
          children: (item.headings || []).map(buildHeadingPayload),
        };
        if (item.id) sg.id = item.id;
        return sg;
      }
      return buildHeadingPayload(item);
    });

    const payload = {
      templateName: draft.templateName.trim(),
      templateDescription: draft.templateDescription.trim(),
      global: draft.global,
      active: draft.active,
      exportToOtherAuthors: draft.exportToOtherAuthors,
      sectionBreak: false,
      sectionHeadings,
      cannedTextsWithHeadings,
    };

    if (isNewTemplate) {
      saveDictationTemplate(payload)
        .then(res => {
          if (res?.data?.success) {
            notification.success({ message: 'Template created' });
            const created = Array.isArray(res.data.result) ? res.data.result[0] : res.data.result;
            const newId = created?.id || created?.templateId;
            setIsNewTemplate(false);
            draftSnapshotRef.current = JSON.stringify(draft);
            isSaveUpdateRef.current = true;
            setSelectedTemplate(prev => ({
              ...prev,
              id: newId,
              templateName: draft.templateName.trim(),
              templateDescription: draft.templateDescription.trim(),
              global: draft.global,
              active: draft.active,
              exportToOtherAuthors: draft.exportToOtherAuthors,
              sectionHeadings,
            }));
            refetchTemplates();
            if (typeof onSuccess === 'function') onSuccess();
          } else {
            notification.error({ message: res?.data?.message || 'Failed to create template' });
          }
        })
        .catch(() => { notification.error({ message: 'Failed to create template' }); })
        .finally(() => setSaveLoading(false));
    } else {
      editDictationTemplate({ id: selectedTemplate.id, ...payload })
        .then(res => {
          if (res?.data?.success) {
            notification.success({ message: 'Template saved' });
            draftSnapshotRef.current = JSON.stringify(draft);
            isSaveUpdateRef.current = true;
            const updated = Array.isArray(res.data.result) ? res.data.result[0] : res.data.result;
            setSelectedTemplate(prev => ({
              ...prev,
              templateName: draft.templateName.trim(),
              templateDescription: draft.templateDescription.trim(),
              global: draft.global,
              active: draft.active,
              exportToOtherAuthors: draft.exportToOtherAuthors,
              sectionHeadings: updated?.sectionHeadings ?? sectionHeadings,
            }));
            if (typeof onSuccess === 'function') onSuccess();
          } else {
            notification.error({ message: res?.data?.message || 'Failed to save template' });
          }
        })
        .catch(() => { notification.error({ message: 'Failed to save template' }); })
        .finally(() => setSaveLoading(false));
    }
  };

  const handleDelete = () => {
    setDeleteForAllUsers(false);
    setDeleteModalVisible(true);
  };

  const confirmDelete = () => {
    setDeleteLoading(true);
    removeDictationTemplate(selectedTemplate.id, deleteForAllUsers)
      .then(res => {
        if (res?.data?.success) {
          notification.success({ message: 'Template deleted' });
          setDeleteModalVisible(false);
          setSelectedTemplate(null);
          refetchTemplates();
        }
      })
      .catch(() => {})
      .finally(() => setDeleteLoading(false));
  };

  const handleBackToList = () => {
    setSelectedTemplate(null);
    setIsNewTemplate(false);
    if (!isNewTemplate) refetchTemplates();
  };

  const toggleItemCollapse = itemId => {
    setCollapsedItems(prev => {
      const next = new Set(prev);
      if (next.has(itemId)) next.delete(itemId); else next.add(itemId);
      return next;
    });
  };

  const handleDragEnd = result => {
    if (!result.destination) return;
    const { source, destination } = result;
    if (source.droppableId === destination.droppableId && source.index === destination.index) return;

    if (source.droppableId.startsWith('group-headings-')) {
      const groupId = source.droppableId.replace('group-headings-', '');
      setDraft(d => ({
        ...d,
        items: d.items.map(item => {
          if (item.id !== groupId) return item;
          const headings = [...item.headings];
          const [moved] = headings.splice(source.index, 1);
          headings.splice(destination.index, 0, moved);
          return { ...item, headings };
        }),
      }));
      return;
    }

    if (source.droppableId !== 'items') return;

    const items = [...draft.items];
    const [moved] = items.splice(source.index, 1);
    items.splice(destination.index, 0, moved);
    setDraft(d => ({ ...d, items }));
  };

  const handleGroupHeadingDragEnd = (groupId, result) => {
    if (!result.destination || result.source.index === result.destination.index) return;
    setDraft(d => ({
      ...d,
      items: d.items.map(item => {
        if (item.id !== groupId) return item;
        const headings = [...item.headings];
        const [moved] = headings.splice(result.source.index, 1);
        headings.splice(result.destination.index, 0, moved);
        return { ...item, headings };
      }),
    }));
  };

  const handleAddHeading = () => {
    const name = newHeadingName.trim();
    if (!name) return;
    setDraft(d => ({
      ...d,
      items: [
        ...d.items,
        {
          type: 'heading',
          id: `h-${Date.now()}`,
          customUIHeading: name,
          systemHeading: 'None',
          description: '',
          defaultValue: '',
          appendToDefault: false,
          submitToEmr: true,
          suppressOnEmpty: false,
          useAI: false,
          aiPrompt: null,
          required: false,
          sectionType: 'dictate',
          options: [],
        },
      ],
    }));
    setAddHeadingModalOpen(false);
    setNewHeadingName('');
  };

  const handleAddSectionGroup = () => {
    const name = newSectionGroupName.trim();
    if (!name) return;
    setDraft(d => ({
      ...d,
      items: [
        ...d.items,
        {
          type: 'sectionGroup',
          id: `group-${Date.now()}`,
          title: name,
          push_title_to_note: newSectionGroupPushTitle,
          headings: [],
        },
      ],
    }));
    setAddSectionGroupModalOpen(false);
    setNewSectionGroupName('');
    setNewSectionGroupPushTitle(false);
  };

  const removeGroup = groupId => {
    const group = draft.items.find(i => i.id === groupId);
    const name = group?.title || 'Section Group';
    Modal.confirm({
      title: 'Remove section group?',
      content: `"${name}" and all its headings will be removed.`,
      okText: 'Remove',
      okType: 'danger',
      okButtonProps: { style: { borderRadius: 6 } },
      cancelButtonProps: { style: { borderRadius: 6 } },
      style: { top: 200 },
      wrapClassName: 'template-new-modal',
      onOk: () => {
        setDraft(d => ({ ...d, items: d.items.filter(i => i.id !== groupId) }));
        setCollapsedItems(prev => { const next = new Set(prev); next.delete(groupId); return next; });
      },
    });
  };

  const updateGroup = (groupId, field, value) => {
    setDraft(d => ({
      ...d,
      items: d.items.map(item => item.id === groupId ? { ...item, [field]: value } : item),
    }));
  };

  const handleAddHeadingToGroup = () => {
    const name = newGroupHeadingName.trim();
    if (!name) return;
    const { groupId } = addGroupHeadingModal;
    const headingId = `gh-${Date.now()}`;
    setDraft(d => ({
      ...d,
      items: d.items.map(item => {
        if (item.id !== groupId) return item;
        return {
          ...item,
          headings: [
            ...item.headings,
            {
              id: headingId,
              customUIHeading: name,
              systemHeading: 'None',
              description: '',
              defaultValue: '',
              appendToDefault: false,
              submitToEmr: true,
              suppressOnEmpty: false,
              useAI: false,
              aiPrompt: null,
              required: false,
              sectionType: 'dictate',
              options: [],
            },
          ],
        };
      }),
    }));
    setAddGroupHeadingModal({ open: false, groupId: null });
    setNewGroupHeadingName('');
  };

  const updateGroupHeading = (groupId, headingId, field, value) => {
    setDraft(d => ({
      ...d,
      items: d.items.map(item => {
        if (item.id !== groupId) return item;
        return {
          ...item,
          headings: item.headings.map(h => h.id === headingId ? { ...h, [field]: value } : h),
        };
      }),
    }));
  };

  const removeGroupHeading = (groupId, headingId, headingName) => {
    Modal.confirm({
      title: 'Remove heading?',
      content: `"${headingName}" will be removed from this section group.`,
      okText: 'Remove',
      okType: 'danger',
      okButtonProps: { style: { borderRadius: 6 } },
      cancelButtonProps: { style: { borderRadius: 6 } },
      style: { top: 200 },
      wrapClassName: 'template-new-modal',
      onOk: () => {
        setDraft(d => ({
          ...d,
          items: d.items.map(item => {
            if (item.id !== groupId) return item;
            return { ...item, headings: item.headings.filter(h => h.id !== headingId) };
          }),
        }));
        setCollapsedGroupHeadings(prev => { const next = new Set(prev); next.delete(headingId); return next; });
      },
    });
  };

  const toggleGroupHeadingCollapse = headingId => {
    setCollapsedGroupHeadings(prev => {
      const next = new Set(prev);
      if (next.has(headingId)) next.delete(headingId); else next.add(headingId);
      return next;
    });
  };

  const removeHeading = (itemId, headingName) => {
    Modal.confirm({
      title: 'Remove heading?',
      content: `"${headingName}" will be removed from this template.`,
      okText: 'Remove',
      okType: 'danger',
      okButtonProps: { style: { borderRadius: 6 } },
      cancelButtonProps: { style: { borderRadius: 6 } },
      style: { top: 200 },
      wrapClassName: 'template-new-modal',
      onOk: () => {
        setDraft(d => ({ ...d, items: d.items.filter(i => i.id !== itemId) }));
        setCollapsedItems(prev => { const next = new Set(prev); next.delete(itemId); return next; });
      },
    });
  };

  const updateHeading = (itemId, field, value) => {
    setDraft(d => ({
      ...d,
      items: d.items.map(i => i.id === itemId ? { ...i, [field]: value } : i),
    }));
  };

  const filteredK2ps = k2ps.filter(k =>
    (k.key || '').toLowerCase().includes(k2pFilter.toLowerCase()) ||
    (k.phrase || '').toLowerCase().includes(k2pFilter.toLowerCase())
  );

  const removeSpaces = str => str.replace(/\s/g, '');

  const fetchAuthorData = async () => {
    setImportModalVisible(true);
    setLoadingAuthor(true);
    try {
      const res = await listDictationTemplate('author', authPage, 50, searchQueryAuthor);
      const fresh = (res.data.result || []).filter(
        newItem => !cannedTextAuthor.some(old => old.id === newItem.id)
      );
      setCannedTextsAuthor(prev => [...prev, ...fresh]);
      setCannedTextAuthorSize(res.data.size || 0);
    } catch (e) {
      console.error(e);
    } finally {
      setLoadingAuthor(false);
    }
  };

  const handleImportCancel = () => {
    setImportModalVisible(false);
    setSelectedCard(null);
  };

  const handleImport = (overRideExisting = false) => {
    authorsCollectionToMyCollectionDict(checkedCardIds, overRideExisting, importActive, importExportToOtherAuthors)
      .then(res => {
        if (res?.data?.success) {
          notification.success({ message: res?.data?.message });
          setImportModalVisible(false);
          setCheckedCards([]);
          setCheckedCardIds([]);
          setSelectedCard(null);
          setImportActive(false);
          setImportExportToOtherAuthors(false);
          setImportErrorModalVisible(false);
          refetchTemplates();
        } else {
          notification.error({ message: res?.data?.message });
          setImportActive(false);
          setImportExportToOtherAuthors(false);
        }
      });
  };

  const isConflict = () => {
    const hasConflict = checkedCardIds.some(id => {
      const card = cannedTextAuthor.find(item => item.id === id);
      return card && card.conflict === true;
    });
    if (hasConflict) {
      setImportErrorModalVisible(true);
    } else {
      handleImport();
    }
  };

  const handleImportSkip = () => handleImport();
  const handleImportReplace = () => handleImport(true);

  const handleImportCheckboxChange = (card, checked) => {
    if (checked) {
      const duplicate = checkedCards.find(
        item => removeSpaces(item.templateName) === removeSpaces(card.templateName)
      );
      if (duplicate) {
        message.error('This card is already checked!');
      } else {
        setCheckedCards(prev => [...prev, card]);
      }
    } else {
      setCheckedCards(prev => prev.filter(item => item.id !== card.id));
    }
    if (checkedCardIds.includes(card.id)) {
      setCheckedCardIds(prev => prev.filter(id => id !== card.id));
    } else {
      setCheckedCardIds(prev => [...prev, card.id]);
    }
  };

  const handleSearchAuthor = e => {
    const val = e.target.value;
    clearTimeout(importSearchTimerRef.current);
    importSearchTimerRef.current = setTimeout(() => {
      setCannedTextsAuthor([]);
      setAuthPage(0);
      setSearchQueryAuthor(val);
    }, 800);
  };

  const handleScrollAuthor = e => {
    const el = e.target;
    if (el.scrollHeight - el.scrollTop < el.clientHeight + 2) {
      if (!loadingAuthor && cannedTextAuthorSize > cannedTextAuthor.length) {
        fetchAuthorData();
      }
    }
  };

  const refetchK2ps = () => {
    getAllCannedText('allMine')
      .then(res => {
        if (res?.data?.result) setK2ps(res.data.result);
      })
      .catch(() => {});
  };

  const handleCreateK2p = () => {
    setCreateK2pModalVisible(true);
    if (!editK2pDynamicEndPoints.length) {
      targetEndPoints()
        .then(res => {
          if (res?.data?.success) setEditK2pDynamicEndPoints(res.data.result || []);
        })
        .catch(() => {});
    }
  };

  const handleK2pDoubleClick = k => {
    setEditK2pItem(k);
    if (!editK2pDynamicEndPoints.length) {
      targetEndPoints()
        .then(res => {
          if (res?.data?.success) setEditK2pDynamicEndPoints(res.data.result || []);
        })
        .catch(() => {});
    }
  };

  const renderHeadingBody = (h, updateFn) => (
    <>
      <div style={{ display: 'flex', gap: 10, marginBottom: 14 }}>
        <div style={{ flex: 1 }}>
          <SubLabel>Heading name</SubLabel>
          <Input
            value={h.customUIHeading || ''}
            onChange={e => updateFn('customUIHeading', e.target.value)}
            style={{ borderRadius: 6, fontSize: 13 }}
          />
        </div>
        <div style={{ width: 240 }}>
          <SubLabel>System heading</SubLabel>
          <Select
            value={h.systemHeading || 'None'}
            onChange={v => updateFn('systemHeading', v)}
            style={{ width: '100%', fontSize: 13 }}
            size='middle'
            virtual={false}
            className='heading-system-select'
          >
            <Select.Option value='None'>None</Select.Option>
            {systemSections.filter(s => s !== 'None').map(s => (
              <Select.Option key={s} value={s}>{s}</Select.Option>
            ))}
          </Select>
        </div>
      </div>

      <ToggleGrid>
        <ToggleRow>Required<Switch size='small' checked={h.required} onChange={v => updateFn('required', v)} /></ToggleRow>
        <ToggleRow>Submit to EMR<Switch size='small' checked={h.submitToEmr} onChange={v => updateFn('submitToEmr', v)} /></ToggleRow>
        <ToggleRow>Suppress if empty<Switch size='small' checked={h.suppressOnEmpty} onChange={v => updateFn('suppressOnEmpty', v)} /></ToggleRow>
        {(h.sectionType !== 'checkbox' && h.sectionType !== 'droplist') && (
          <ToggleRow>Append to default<Switch size='small' checked={h.appendToDefault} onChange={v => updateFn('appendToDefault', v)} /></ToggleRow>
        )}
        {(h.sectionType !== 'checkbox' && h.sectionType !== 'droplist') && (
          <ToggleRow>Generate with AI<Switch size='small' checked={h.useAI} onChange={v => updateFn('useAI', v)} /></ToggleRow>
        )}
      </ToggleGrid>

      <>
          <SubLabel style={{ marginTop: 2 }}>Section type</SubLabel>
          <SectionTypeBar>
            {['dictate', 'checkbox', 'droplist'].map(type => (
              <SectionTypeBtn
                key={type}
                active={(!h.sectionType && type === 'dictate') || h.sectionType === type}
                onClick={() => {
                  updateFn('sectionType', type);
                  if (type === 'checkbox' || type === 'droplist') {
                    updateFn('useAI', false);
                    updateFn('aiPrompt', null);
                  }
                }}
              >
                {type.charAt(0).toUpperCase() + type.slice(1)}
              </SectionTypeBtn>
            ))}
          </SectionTypeBar>
          {(h.sectionType === 'checkbox' || h.sectionType === 'droplist') && (
            <OptionListWrap>
              <SubLabel>Options</SubLabel>
              {(h.options || []).length === 0 && (
                <div style={{ fontSize: 12, color: '#bfbfbf', marginBottom: 8 }}>No options yet. Add at least one.</div>
              )}
              <DragDropContext onDragEnd={result => {
                if (!result.destination || result.source.index === result.destination.index) return;
                const opts = [...(h.options || [])];
                const [moved] = opts.splice(result.source.index, 1);
                opts.splice(result.destination.index, 0, moved);
                updateFn('options', opts);
              }}>
                <Droppable droppableId={`opts-${h.id}`}>
                  {provided => (
                    <div ref={provided.innerRef} {...provided.droppableProps}>
                      {(h.options || []).map((opt, i) => (
                        <Draggable key={`${h.id}-opt-${i}`} draggableId={`${h.id}-opt-${i}`} index={i}>
                          {dragProvided => (
                            <OptionRow ref={dragProvided.innerRef} {...dragProvided.draggableProps}>
                              <span
                                {...dragProvided.dragHandleProps}
                                style={{ color: '#bfbfbf', cursor: 'grab', display: 'flex', alignItems: 'center', flexShrink: 0 }}
                              >
                                <DragIndicatorIcon />
                              </span>
                              <Input
                                placeholder='Value'
                                value={opt.value}
                                onChange={e => {
                                  const opts = [...(h.options || [])];
                                  opts[i] = { ...opts[i], value: e.target.value };
                                  updateFn('options', opts);
                                }}
                                style={{ width: '50%', fontSize: 12, borderRadius: 6 }}
                              />
                              <Button
                                type='text'
                                size='small'
                                danger
                                icon={<DeleteOutlined />}
                                onClick={() => updateFn('options', (h.options || []).filter((_, idx) => idx !== i))}
                              />
                            </OptionRow>
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
              <AddOptionBtn
                type='button'
                onClick={() => updateFn('options', [...(h.options || []), { value: '' }])}
              >
                <PlusOutlined /> Add option
              </AddOptionBtn>
            </OptionListWrap>
          )}
      </>

      {(h.sectionType !== 'checkbox' && h.sectionType !== 'droplist') && <>
      <SubLabel>Default text</SubLabel>
      <div
        key={`hdc-${selectedTemplate?.id}-${h.id}`}
        ref={el => {
          if (el && headingContentRefs.current[h.id] !== el) {
            headingContentRefs.current[h.id] = el;
            el.innerHTML = h.defaultValue || '';
          }
        }}
        className='heading-default-editor'
        contentEditable
        suppressContentEditableWarning
        data-placeholder='Type default text or drag a K2P from the panel →'
        onInput={e => updateFn('defaultValue', e.currentTarget.innerHTML)}
        onClick={e => {
          if (e.target.dataset.action === 'k2p-remove') {
            e.preventDefault();
            e.stopPropagation();
            const k2pId = e.target.dataset.k2pId;
            const pill = e.target.closest('.k2p-token');
            if (pill && k2pId) {
              pill.remove();
              updateFn('defaultValue', headingContentRefs.current[h.id].innerHTML);
              const stillUsed = Object.values(headingContentRefs.current).some(
                ref => ref && ref.querySelector(`[data-k2p-id="${k2pId}"]`)
              );
              if (!stillUsed) setUsedK2pIds(prev => { const next = new Set(prev); next.delete(k2pId); return next; });
            }
          }
        }}
        onDragOver={e => { e.preventDefault(); e.currentTarget.classList.add('drag-over'); }}
        onDragLeave={e => { e.currentTarget.classList.remove('drag-over'); }}
        onDrop={e => {
          e.preventDefault();
          e.currentTarget.classList.remove('drag-over');
          const k2pId = e.dataTransfer.getData('k2pId');
          const k2pKey = e.dataTransfer.getData('k2pKey');
          if (!k2pId || !k2pKey) return;
          const pill = `<span data-k2p-id="${k2pId}" contenteditable="false" class="k2p-token">${k2pKey}<span data-action="k2p-remove" data-k2p-id="${k2pId}" class="k2p-token-remove">×</span></span>`;
          const ref = headingContentRefs.current[h.id];
          const el = document.createElement('span');
          el.innerHTML = pill;
          const pillNode = el.firstChild;
          const range = document.createRange();
          let target = ref;
          while (target.lastChild && target.lastChild.nodeType === Node.ELEMENT_NODE && /^(P|DIV|H[1-6]|BLOCKQUOTE|LI)$/.test(target.lastChild.tagName)) {
            target = target.lastChild;
          }
          if (target.childNodes.length === 1 && target.firstChild?.nodeName === 'BR') {
            target.removeChild(target.firstChild);
          }
          range.selectNodeContents(target);
          range.collapse(false);
          range.insertNode(pillNode);
          range.setStartAfter(pillNode);
          range.collapse(true);
          const sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(range);
          updateFn('defaultValue', headingContentRefs.current[h.id].innerHTML);
          setUsedK2pIds(prev => new Set([...prev, k2pId]));
        }}
      />
      </>}

      <SubLabel>
        Tooltip text <span style={{ fontWeight: 400, textTransform: 'none', letterSpacing: 0, fontSize: 11 }}>(optional)</span>
      </SubLabel>
      <HeadingTextArea
        value={h.description || ''}
        onChange={e => updateFn('description', e.target.value)}
        placeholder='Add guidance text shown to the doctor...'
        autoSize={{ minRows: 2, maxRows: 4 }}
      />

      {h.useAI && h.sectionType !== 'checkbox' && h.sectionType !== 'droplist' && (
        <AiPromptWrap>
          <AiPromptHead>✦ AI prompt</AiPromptHead>
          <AiPromptField
            value={h.aiPrompt || ''}
            onChange={e => updateFn('aiPrompt', e.target.value)}
            placeholder='Enter the AI prompt for this section...'
            autoSize={{ minRows: 2, maxRows: 6 }}
            bordered={false}
          />
        </AiPromptWrap>
      )}
    </>
  );

  const renderItems = () => {
    if (!draft?.items?.length) return null;
    return (
      <DragDropContext onDragEnd={handleDragEnd}>
        <Droppable droppableId='items'>
          {provided => (
            <div ref={provided.innerRef} {...provided.droppableProps}>
              {draft.items.map((item, index) => {
                if (item.type === 'heading') {
                  const isOpen = !collapsedItems.has(item.id);
                  const systemHeading = item.systemHeading && item.systemHeading !== 'None' ? item.systemHeading : null;
                  return (
                    <Draggable key={item.id} draggableId={item.id} index={index}>
                      {(dragProvided, dragSnapshot) => (
                        <HeadingCard
                          ref={dragProvided.innerRef}
                          {...dragProvided.draggableProps}
                          style={{ ...dragProvided.draggableProps.style, opacity: dragSnapshot.isDragging ? 0.85 : 1 }}
                        >
                          <HeadingHeader open={isOpen} onClick={() => toggleItemCollapse(item.id)}>
                            <HeadingGrip {...dragProvided.dragHandleProps} onClick={e => e.stopPropagation()}>
                              <DragIndicatorIcon color='#bfbfbf' />
                            </HeadingGrip>
                            <HeadingTitle>{item.customUIHeading || `Heading ${index + 1}`}</HeadingTitle>
                            {systemHeading && <HeadingSystemTag>{systemHeading}</HeadingSystemTag>}
                            <Button
                              size='small' danger type='text'
                              onClick={e => { e.stopPropagation(); removeHeading(item.id, item.customUIHeading || `Heading ${index + 1}`); }}
                              style={{ fontSize: 11, padding: '0 6px', height: 22, flexShrink: 0 }}
                            >Remove</Button>
                            <HeadingChevron open={isOpen}><DownOutlined /></HeadingChevron>
                          </HeadingHeader>
                          <HeadingBody open={isOpen}>
                            {renderHeadingBody(item, (field, value) => updateHeading(item.id, field, value))}
                          </HeadingBody>
                        </HeadingCard>
                      )}
                    </Draggable>
                  );
                }

                if (item.type === 'sectionGroup') {
                  const isGroupOpen = !collapsedItems.has(item.id);
                  return (
                    <Draggable key={item.id} draggableId={item.id} index={index}>
                      {(dragProvided, dragSnapshot) => (
                        <SectionGroupCard
                          ref={dragProvided.innerRef}
                          {...dragProvided.draggableProps}
                          style={{ ...dragProvided.draggableProps.style, opacity: dragSnapshot.isDragging ? 0.85 : 1 }}
                        >
                          <SectionGroupHeader open={isGroupOpen} onClick={() => toggleItemCollapse(item.id)}>
                            <HeadingGrip {...dragProvided.dragHandleProps} onClick={e => e.stopPropagation()}>
                              <DragIndicatorIcon color='#bfbfbf' />
                            </HeadingGrip>
                            <SectionGroupTitle>{item.title}</SectionGroupTitle>
                            {item.push_title_to_note && <SectionGroupBadge>Included in note</SectionGroupBadge>}
                            <Button
                              size='small' danger type='text'
                              onClick={e => { e.stopPropagation(); removeGroup(item.id); }}
                              style={{ fontSize: 11, padding: '0 6px', height: 22, flexShrink: 0 }}
                            >Remove</Button>
                            <HeadingChevron open={isGroupOpen}><DownOutlined /></HeadingChevron>
                          </SectionGroupHeader>

                          <SectionGroupBody open={isGroupOpen}>
                            <div style={{ marginBottom: 14 }}>
                              <SubLabel>Group name</SubLabel>
                              <Input
                                value={item.title || ''}
                                onChange={e => updateGroup(item.id, 'title', e.target.value)}
                                style={{ borderRadius: 6, fontSize: 13 }}
                                onClick={e => e.stopPropagation()}
                              />
                              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 10 }}>
                                <Switch
                                  size='small'
                                  checked={!!item.push_title_to_note}
                                  onChange={v => updateGroup(item.id, 'push_title_to_note', v)}
                                />
                                <SubLabel style={{ marginBottom: 0 }}>Include group title in note</SubLabel>
                              </div>
                            </div>
                            <Droppable droppableId={`group-headings-${item.id}`}>
                              {innerProvided => (
                                <div ref={innerProvided.innerRef} {...innerProvided.droppableProps}>
                                  {item.headings.map((h, hi) => {
                                    const isHOpen = !collapsedGroupHeadings.has(h.id);
                                    const sysH = h.systemHeading && h.systemHeading !== 'None' ? h.systemHeading : null;
                                    return (
                                      <Draggable key={h.id} draggableId={h.id} index={hi}>
                                        {(hp, hs) => (
                                          <HeadingCard
                                            ref={hp.innerRef}
                                            {...hp.draggableProps}
                                            style={{ ...hp.draggableProps.style, opacity: hs.isDragging ? 0.85 : 1 }}
                                          >
                                            <HeadingHeader open={isHOpen} onClick={() => toggleGroupHeadingCollapse(h.id)}>
                                              <HeadingGrip {...hp.dragHandleProps} onClick={e => e.stopPropagation()}>
                                                <DragIndicatorIcon color='#bfbfbf' />
                                              </HeadingGrip>
                                              <HeadingTitle>{h.customUIHeading || `Heading ${hi + 1}`}</HeadingTitle>
                                              {sysH && <HeadingSystemTag>{sysH}</HeadingSystemTag>}
                                              <Button
                                                size='small' danger type='text'
                                                onClick={e => { e.stopPropagation(); removeGroupHeading(item.id, h.id, h.customUIHeading || `Heading ${hi + 1}`); }}
                                                style={{ fontSize: 11, padding: '0 6px', height: 22, flexShrink: 0 }}
                                              >Remove</Button>
                                              <HeadingChevron open={isHOpen}><DownOutlined /></HeadingChevron>
                                            </HeadingHeader>
                                            <HeadingBody open={isHOpen}>
                                              {renderHeadingBody(h, (field, value) => updateGroupHeading(item.id, h.id, field, value))}
                                            </HeadingBody>
                                          </HeadingCard>
                                        )}
                                      </Draggable>
                                    );
                                  })}
                                  {innerProvided.placeholder}
                                </div>
                              )}
                            </Droppable>
                            <AddGroupHeadingBtn
                              onClick={() => { setNewGroupHeadingName(''); setAddGroupHeadingModal({ open: true, groupId: item.id }); }}
                            >
                              <PlusOutlined /> Add heading
                            </AddGroupHeadingBtn>
                          </SectionGroupBody>
                        </SectionGroupCard>
                      )}
                    </Draggable>
                  );
                }

                return null;
              })}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    );
  };

  const renderK2pSidebar = () => (
    <>
      <K2pPanelHeader>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
          <h4 style={{ margin: 0 }}>Key to Phrase</h4>
          <Button size='small' type='primary' shape='round' icon={<PlusOutlined />} onClick={handleCreateK2p}>
            Create New K2P
          </Button>
        </div>
        <K2pPanelSearch
          placeholder='Search K2Ps...'
          prefix={<SearchOutlined />}
          value={k2pFilter}
          onChange={e => setK2pFilter(e.target.value)}
          size='small'
        />
      </K2pPanelHeader>
      <K2pPanelScroll>
        {k2pLoading ? (
          <Spinner height='120px' />
        ) : filteredK2ps.length === 0 ? (
          <div style={{ fontSize: 12, color: '#8c8c8c', textAlign: 'center', paddingTop: 20 }}>
            {k2pFilter ? 'No K2Ps match your search' : 'No K2Ps available'}
          </div>
        ) : (
          <>
            {filteredK2ps.filter(k => usedK2pIds.has(k.id)).length > 0 && (
              <K2pSectionLabel style={{ color: '#1d7ec2' }}>In use</K2pSectionLabel>
            )}
            {filteredK2ps.filter(k => usedK2pIds.has(k.id)).map(k => (
              <K2pItem
                key={k.id}
                inUse
                draggable
                onDragStart={e => {
                  e.dataTransfer.setData('k2pId', k.id);
                  e.dataTransfer.setData('k2pKey', k.key);
                }}
                onDoubleClick={() => handleK2pDoubleClick(k)}
              >
                <K2pItemTop>
                  <K2pItemKey>{k.key}</K2pItemKey>
                  <K2pBadge variant='active'>In use</K2pBadge>
                </K2pItemTop>
                <K2pItemPhrase>{stripHtml(k.phrase) || k.phrase}</K2pItemPhrase>
              </K2pItem>
            ))}

            {filteredK2ps.filter(k => !usedK2pIds.has(k.id)).length > 0 && (
              <K2pSectionLabel>Available</K2pSectionLabel>
            )}
            {filteredK2ps.filter(k => !usedK2pIds.has(k.id)).map(k => (
              <K2pItem
                key={k.id}
                draggable
                onDragStart={e => {
                  e.dataTransfer.setData('k2pId', k.id);
                  e.dataTransfer.setData('k2pKey', k.key);
                }}
                onDoubleClick={() => handleK2pDoubleClick(k)}
              >
                <K2pItemTop>
                  <K2pItemKey>{k.key}</K2pItemKey>
                  <K2pBadge>Available</K2pBadge>
                </K2pItemTop>
                <K2pItemPhrase>{stripHtml(k.phrase) || k.phrase}</K2pItemPhrase>
              </K2pItem>
            ))}
          </>
        )}
      </K2pPanelScroll>
    </>
  );

  const isDirty = !!(selectedTemplate && draft && (
    isNewTemplate ||
    (draftSnapshotRef.current && JSON.stringify(draft) !== draftSnapshotRef.current)
  ));

  return (
    <>
      <PageTitle title='Dictation' />
      <ContainerRow device={true}>
        <TitleRow style={{ justifyContent: 'space-between' }}>
          <NavTabs style={{ position: 'absolute', left: '50%', transform: 'translateX(-50%)' }}>
            <NavTab active={true}>Templates</NavTab>
            <NavTab onClick={() => {
              if (isDirty) {
                pendingNavAction.current = () => history.push('/dashboard/settings/key-to-phrase');
                setUnsavedModalVisible(true);
              } else {
                history.push('/dashboard/settings/key-to-phrase');
              }
            }}>
              Key to phrase
            </NavTab>
          </NavTabs>
          <div style={{ marginLeft: 'auto' }}>
            <K2pButtonsecnd
              shape='round'
              onClick={fetchAuthorData}
              icon={<ArrowDownOutlined />}
            >
              Import From Global List
            </K2pButtonsecnd>
          </div>
        </TitleRow>
        <BreadCrumbComponent
          items={[
            { name: 'Settings', path: '/dashboard/settings' },
            { name: 'Templates' },
          ]}
        />
        <PageWrapper>
          {selectedTemplate && draft ? (
            <EditorContainer>
              <EditorBreadcrumb>
                <BreadcrumbLink onClick={() => {
                  if (isDirty) {
                    pendingNavAction.current = handleBackToList;
                    setUnsavedModalVisible(true);
                  } else {
                    handleBackToList();
                  }
                }}><ArrowLeftOutlined style={{ marginRight: 5 }} />Templates</BreadcrumbLink>
                <span style={{ margin: '0 6px' }}>/</span>
                <span style={{ color: '#595959' }}>
                  {draft.templateName || selectedTemplate.templateName}
                </span>
                <EditorActions>
                  {!isNewTemplate && (
                    <Button
                      size='small'
                      danger
                      loading={deleteLoading}
                      onClick={handleDelete}
                      style={{ borderRadius: 6 }}
                    >
                      Delete
                    </Button>
                  )}
                  <Button
                    size='small'
                    type='primary'
                    loading={saveLoading}
                    onClick={handleSave}
                    style={{ borderRadius: 6 }}
                  >
                    {isNewTemplate ? 'Create template' : 'Save template'}
                  </Button>
                </EditorActions>
              </EditorBreadcrumb>
              <EditorLayout>
                <EditorMain>
                  <EditorBody>
                    <FieldGroup>
                      <FieldLabel>
                        Template name <span style={{ color: '#ff4d4f' }}>*</span>
                      </FieldLabel>
                      <Input
                        value={draft.templateName}
                        onChange={e => { const v = e.target.value; setDraft(d => ({ ...d, templateName: v })); }}
                        style={{ borderRadius: 6 }}
                      />
                    </FieldGroup>
                    <FieldGroup>
                      <FieldLabel>Description</FieldLabel>
                      <Input
                        value={draft.templateDescription}
                        onChange={e => { const v = e.target.value; setDraft(d => ({ ...d, templateDescription: v })); }}
                        placeholder='Brief description'
                        style={{ borderRadius: 6 }}
                      />
                    </FieldGroup>
                    <ConfigBar>
                      <ConfigItem>
                        Global availability
                        <Switch
                          size='small'
                          checked={draft.global}
                          onChange={v => setDraft(d => ({ ...d, global: v }))}
                        />
                      </ConfigItem>
                      <ConfigItem>
                        Activate
                        <Switch
                          size='small'
                          checked={draft.active}
                          onChange={v => setDraft(d => ({ ...d, active: v }))}
                        />
                      </ConfigItem>
                      <ConfigItem>
                        Apply to all users
                        <Switch
                          size='small'
                          checked={draft.exportToOtherAuthors}
                          onChange={v => setDraft(d => ({ ...d, exportToOtherAuthors: v }))}
                        />
                      </ConfigItem>
                    </ConfigBar>

                    {draft.items?.length > 0 && (
                      <SectionDivider>
                        <span>Headings</span>
                      </SectionDivider>
                    )}
                    {renderItems()}
                    <Dropdown
                      trigger={['click']}
                      overlay={
                        <Menu>
                          <Menu.Item
                            key='heading'
                            icon={<PlusOutlined />}
                            onClick={() => { setNewHeadingName(''); setAddHeadingModalOpen(true); }}
                          >
                            Heading
                          </Menu.Item>
                          <Menu.Item
                            key='section-group'
                            icon={<PlusOutlined />}
                            onClick={() => { setNewSectionGroupName(''); setNewSectionGroupPushTitle(false); setAddSectionGroupModalOpen(true); }}
                          >
                            Section Group
                          </Menu.Item>
                        </Menu>
                      }
                    >
                      <AddHeadingBtn>
                        <PlusOutlined /> Add <DownOutlined style={{ fontSize: 10, marginLeft: 2 }} />
                      </AddHeadingBtn>
                    </Dropdown>
                  </EditorBody>
                </EditorMain>
                <EditorRight>
                  {renderK2pSidebar()}
                </EditorRight>
              </EditorLayout>
            </EditorContainer>
          ) : (
            <>
              <Sidebar>
                <SidebarHeader style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span>My templates</span>
                  <Button size='small' type='primary' shape='round' icon={<PlusOutlined />} onClick={openModal} style={{ fontWeight: 400, letterSpacing: 0, textTransform: 'none', fontSize: 12 }}>
                    New template
                  </Button>
                </SidebarHeader>
                <div style={{ padding: '8px 12px 4px' }}>
                  <Button
                    block
                    shape='round'
                    size='small'
                    onClick={() => setAiGenerateModalOpen(true)}
                    style={{ fontSize: 12, color: '#fff', borderColor: '#47a4ea', background: '#47a4ea', fontWeight: 500 }}
                  >
                    ✦ Generate with AI
                  </Button>
                </div>
                <SidebarSearch
                  placeholder='Search templates...'
                  prefix={<SearchOutlined />}
                  value={searchValue}
                  onChange={handleSearch}
                />
                <TemplateListScroll>
                  {loading ? (
                    <Spinner height='200px' />
                  ) : filteredTemplates.map(t => {
                    const headingCount = t.sectionHeadings?.length ?? 0;
                    const meta = [
                      t.templateDescription,
                      `${headingCount} heading${headingCount !== 1 ? 's' : ''}`,
                    ]
                      .filter(Boolean)
                      .join(' · ');

                    return (
                      <TemplateItem key={t.id} onClick={() => {
                          if (!t.editable) {
                            notification.warning({
                              message: 'Read-only template',
                              description: 'This template was created by an admin and cannot be edited.'
                            });
                          }
                          setSelectedTemplate(t);
                        }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 2 }}>
                          <TemplateName style={{ margin: 0 }}>{t.templateName}</TemplateName>
                          <Tag color={t.active ? 'green' : 'default'} style={{ marginRight: 0, borderRadius: 10, flexShrink: 0 }}>
                            {t.active ? 'Active' : 'Inactive'}
                          </Tag>
                        </div>
                        <TemplateMeta>{meta}</TemplateMeta>
                      </TemplateItem>
                    );
                  })}
                </TemplateListScroll>
              </Sidebar>
              <MainPanel>
                <EmptyState>
                  <EmptyStateIcon>📋</EmptyStateIcon>
                  <EmptyStateText>Select a template to edit</EmptyStateText>
                  <EmptyStateSubtext>or create a new one from the list</EmptyStateSubtext>
                </EmptyState>
              </MainPanel>
            </>
          )}
        </PageWrapper>
      </ContainerRow>

      <CustomModal
        title='Import Dictation Template'
        visible={importModalVisible}
        onCancel={handleImportCancel}
        footer={
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '8px', marginBottom: '8px' }}>
            <div style={{ display: 'flex', gap: '16px' }}>
              <Checkbox checked={importActive} onChange={e => setImportActive(e.target.checked)}>
                <strong>Import as Active</strong>
              </Checkbox>
              {(user?.userType === 'admin' || user?.userType === 'clinicAdmin') && (
                <Checkbox checked={importExportToOtherAuthors} onChange={e => setImportExportToOtherAuthors(e.target.checked)}>
                  <strong>Apply to all users</strong>
                </Checkbox>
              )}
            </div>
            <div>
              <AddButton key='cancel' shape='round' onClick={handleImportCancel}>
                Cancel
              </AddButton>
              <AddButton
                key='import'
                type='primary'
                icon={<DownloadOutlined />}
                shape='round'
                onClick={isConflict}
                style={{ marginLeft: '8px' }}
              >
                Import selected
              </AddButton>
            </div>
          </div>
        }
      >
        <Row gutter={[16, 16]} style={{ marginRight: '2px' }}>
          <Col span={9}>
            <div style={{ display: 'flex', flexDirection: 'column', position: 'relative' }}>
              <SearchInputStylee
                placeholder='Search'
                prefix={<SearchOutlined />}
                onChange={handleSearchAuthor}
                style={{ marginBottom: '10px', paddingLeft: '29px' }}
              />
              <SearchDivider />
              {loadingAuthor ? (
                <Spinner height='52vh' />
              ) : cannedTextAuthor.length === 0 ? (
                <div style={{ padding: '20px', color: '#8c8c8c', textAlign: 'center' }}>No data available</div>
              ) : (
                <div style={{ maxHeight: '440px', overflowY: 'auto', marginLeft: '17px' }} onScroll={handleScrollAuthor}>
                  {cannedTextAuthor.map(item => (
                    <KpCol
                      key={item.id}
                      onClick={() => setSelectedCard(item)}
                    >
                      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '6px' }}>
                        <div style={{ display: 'flex', alignItems: 'baseline' }}>
                          <Checkbox
                            checked={checkedCards.some(c => c.id === item.id)}
                            onChange={e => handleImportCheckboxChange(item, e.target.checked)}
                          />
                          <h3 className='keyvalue' style={{ marginLeft: 8 }}>
                            {item.templateName?.length > 25 ? item.templateName.substring(0, 25) + '...' : item.templateName}
                          </h3>
                        </div>
                        <Tooltip
                          placement='topRight'
                          title={
                            <div>
                              <ExclamationCircleOutlined style={{ color: 'orange' }} />
                              <span style={{ marginLeft: 8 }}>A template with this name already exists in your collection</span>
                            </div>
                          }
                        >
                          {item.conflict && (
                            <ExclamationCircleOutlined style={{ color: '#E17F37', marginLeft: 'auto' }} />
                          )}
                        </Tooltip>
                      </div>
                      {item.author && (
                        <div className='author-box'>By: {item.author.doctorName}</div>
                      )}
                    </KpCol>
                  ))}
                </div>
              )}
              <Divider type='vertical' style={{ height: '100%', position: 'absolute', right: 0, top: 0 }} />
            </div>
          </Col>
          <Col span={15} style={{ backgroundColor: '#F5F7FA', height: '490px' }}>
            {selectedCard && (
              <>
                <Row gutter={[16, 16]}>
                  <Col span={24} style={{ marginTop: '12px' }}>
                    <h5 style={{ marginLeft: 8, fontFamily: 'Krub', fontWeight: 600 }}>Template Name</h5>
                    <h2 style={{ marginLeft: 8 }}>{selectedCard.templateName}</h2>
                  </Col>
                </Row>
                <Divider style={{ margin: '16px 0' }} />
                <Row gutter={[16, 16]}>
                  <Col span={24}>
                    <h5 style={{ marginLeft: 8 }}>Headings</h5>
                    <MappedValuesContainer>
                      {(selectedCard.sectionHeadings || []).map((h, i) => (
                        <MappedValues key={i}>
                          <span>{h.customUIHeading}</span>
                          <SwapOutlined />
                          <span>{h.systemHeading}</span>
                        </MappedValues>
                      ))}
                    </MappedValuesContainer>
                  </Col>
                </Row>
              </>
            )}
          </Col>
        </Row>
      </CustomModal>

      <Keytophraseduplication
        title='Import Templates'
        visible={importErrorModalVisible}
        onCancel={() => setImportErrorModalVisible(false)}
        footer={null}
        centered
      >
        <div style={{ flex: 1, marginBottom: '20px' }}>
          The names of certain templates you are attempting to import already exist in your collection. Please choose whether to skip or replace them.
        </div>
        <div className='warning-container' style={{ marginBottom: '20px' }}>
          <ExclamationCircleOutlined style={{ color: 'orange' }} />
          <div className='warning-message'>
            Replacing will permanently overwrite those templates in your collection.
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
          <AddButton type='primary' shape='round' onClick={() => setImportErrorModalVisible(false)}>
            Change selection
          </AddButton>
          <AddButton shape='round' onClick={handleImportSkip}>
            Skip those
          </AddButton>
          <Button danger shape='round' onClick={handleImportReplace}>
            Replace those
          </Button>
        </div>
      </Keytophraseduplication>

      <ModalStyles />

      {editK2pItem && (
        <EditK2pModal
          key={editK2pItem.id}
          item={editK2pItem}
          onClose={() => setEditK2pItem(null)}
          dynamicEndPoints={editK2pDynamicEndPoints}
          onSaveSuccess={updated => setK2ps(prev => prev.map(k => k.id === updated.id ? updated : k))}
          onDeleteSuccess={id => {
            setK2ps(prev => prev.filter(k => k.id !== id));
            setUsedK2pIds(prev => { const next = new Set(prev); next.delete(id); return next; });
          }}
        />
      )}

      {createK2pModalVisible && (
        <CreateK2pModal
          onClose={() => setCreateK2pModalVisible(false)}
          dynamicEndPoints={editK2pDynamicEndPoints}
          onCreateSuccess={refetchK2ps}
        />
      )}

      <AIGenerateModal
        visible={aiGenerateModalOpen}
        onClose={() => setAiGenerateModalOpen(false)}
        k2ps={k2ps}
        onSuccess={generated => {
          setAiGenerateModalOpen(false);
          if (generated) {
            setIsNewTemplate(true);
            setSelectedTemplate({
              templateName: generated.templateName || '',
              templateDescription: generated.templateDescription || '',
              sectionHeadings: generated.sectionHeadings || [],
              sectionGroups: [],
              global: false,
              active: false,
              keytophraseEnabled: true,
              exportToOtherAuthors: false,
            });
          }
        }}
      />

      <Modal
        title='New template'
        visible={modalOpen}
        wrapClassName='template-new-modal'
        onCancel={() => setModalOpen(false)}
        onOk={handleCreate}
        okText='Next'
        okButtonProps={{ disabled: !newName.trim(), style: { borderRadius: 6 } }}
        cancelButtonProps={{ style: { borderRadius: 6 } }}
        width={400}
        style={{ top: 200 }}
        destroyOnClose
      >
        <div style={{ marginBottom: 16 }}>
          <div style={{ fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.04em', color: '#8c8c8c', marginBottom: 4 }}>
            Template name <span style={{ color: '#ff4d4f' }}>*</span>
          </div>
          <Input
            placeholder='e.g. Progress Note'
            value={newName}
            onChange={e => setNewName(e.target.value)}
            onPressEnter={handleCreate}
            autoFocus
            style={{ borderRadius: 6 }}
          />
        </div>
        <div>
          <div style={{ fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.04em', color: '#8c8c8c', marginBottom: 4 }}>
            Description
          </div>
          <Input
            placeholder='Brief description'
            value={newDesc}
            onChange={e => setNewDesc(e.target.value)}
            onPressEnter={handleCreate}
            style={{ borderRadius: 6 }}
          />
        </div>
      </Modal>

      <Modal
        title='Unsaved changes'
        visible={unsavedModalVisible}
        onCancel={() => setUnsavedModalVisible(false)}
        style={{ top: 200 }}
        wrapClassName='template-new-modal'
        footer={[
          <Button key='cancel' shape='round' style={{ borderRadius: 6 }} onClick={() => setUnsavedModalVisible(false)}>
            Cancel
          </Button>,
          <Button key='discard' shape='round' danger style={{ borderRadius: 6 }} onClick={() => {
            setUnsavedModalVisible(false);
            if (pendingNavAction.current) pendingNavAction.current();
            pendingNavAction.current = null;
          }}>
            Discard changes
          </Button>,
          <Button key='save' type='primary' shape='round' style={{ borderRadius: 6 }} loading={saveLoading} onClick={() => {
            handleSave(() => {
              setUnsavedModalVisible(false);
              if (pendingNavAction.current) pendingNavAction.current();
              pendingNavAction.current = null;
            });
          }}>
            Save
          </Button>,
        ]}
        width={420}
        destroyOnClose
      >
        <p style={{ margin: 0 }}>You have unsaved changes in this template. Would you like to save before leaving?</p>
      </Modal>

      <ConfirmationModal
        visible={deleteModalVisible}
        onOk={confirmDelete}
        onCancel={() => { setDeleteModalVisible(false); setDeleteForAllUsers(false); }}
        confirmation={true}
        loading={deleteLoading}
        antdModalProps={{ closable: false, mask: false }}
      >
        <DeleteConfirmationMessage>
          Are you sure you want to delete?
        </DeleteConfirmationMessage>
        {(user?.userType === 'admin' || user?.userType === 'clinicAdmin') && (
          <Checkbox
            checked={deleteForAllUsers}
            onChange={e => setDeleteForAllUsers(e.target.checked)}
            style={{ marginTop: 12, fontSize: 16, color: theme['@text-color'] }}
          >
            Delete for all users
          </Checkbox>
        )}
      </ConfirmationModal>

      <Modal
        title='Add heading'
        visible={addHeadingModalOpen}
        wrapClassName='template-new-modal'
        onCancel={() => setAddHeadingModalOpen(false)}
        onOk={handleAddHeading}
        okText='Add heading'
        okButtonProps={{ disabled: !newHeadingName.trim(), style: { borderRadius: 6 } }}
        cancelButtonProps={{ style: { borderRadius: 6 } }}
        width={400}
        style={{ top: 200 }}
        destroyOnClose
      >
        <div>
          <div style={{ fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.04em', color: '#8c8c8c', marginBottom: 4 }}>
            Heading name <span style={{ color: '#ff4d4f' }}>*</span>
          </div>
          <Input
            placeholder='e.g. Physical Exam'
            value={newHeadingName}
            onChange={e => setNewHeadingName(e.target.value)}
            onPressEnter={handleAddHeading}
            autoFocus
            style={{ borderRadius: 6 }}
          />
        </div>
      </Modal>

      <Modal
        title='Add section group'
        visible={addSectionGroupModalOpen}
        wrapClassName='template-new-modal'
        onCancel={() => setAddSectionGroupModalOpen(false)}
        onOk={handleAddSectionGroup}
        okText='Add section group'
        okButtonProps={{ disabled: !newSectionGroupName.trim(), style: { borderRadius: 6 } }}
        cancelButtonProps={{ style: { borderRadius: 6 } }}
        width={400}
        style={{ top: 200 }}
        destroyOnClose
      >
        <div>
          <div style={{ fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.04em', color: '#8c8c8c', marginBottom: 4 }}>
            Section group title <span style={{ color: '#ff4d4f' }}>*</span>
          </div>
          <Input
            placeholder='e.g. CPT Codes'
            value={newSectionGroupName}
            onChange={e => setNewSectionGroupName(e.target.value)}
            onPressEnter={handleAddSectionGroup}
            autoFocus
            style={{ borderRadius: 6, marginBottom: 16 }}
          />
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontSize: 13, color: '#595959' }}>
            Include title in note text
            <Switch
              size='small'
              checked={newSectionGroupPushTitle}
              onChange={v => setNewSectionGroupPushTitle(v)}
            />
          </div>
          <div style={{ fontSize: 11, color: '#8c8c8c', marginTop: 4 }}>
            When on, the section group title will appear as a line in the generated note.
          </div>
        </div>
      </Modal>

      <Modal
        title='Add heading to section group'
        visible={addGroupHeadingModal.open && !!addGroupHeadingModal.groupId}
        wrapClassName='template-new-modal'
        onCancel={() => setAddGroupHeadingModal({ open: false, groupIndex: null })}
        onOk={handleAddHeadingToGroup}
        okText='Add heading'
        okButtonProps={{ disabled: !newGroupHeadingName.trim(), style: { borderRadius: 6 } }}
        cancelButtonProps={{ style: { borderRadius: 6 } }}
        width={400}
        style={{ top: 200 }}
        destroyOnClose
      >
        <div>
          <div style={{ fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.04em', color: '#8c8c8c', marginBottom: 4 }}>
            Heading name <span style={{ color: '#ff4d4f' }}>*</span>
          </div>
          <Input
            placeholder='e.g. Physical Exam'
            value={newGroupHeadingName}
            onChange={e => setNewGroupHeadingName(e.target.value)}
            onPressEnter={handleAddHeadingToGroup}
            autoFocus
            style={{ borderRadius: 6 }}
          />
        </div>
      </Modal>

    </>
  );
};

export default TemplateList;
